import { useState, type FormEvent } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";

const navItems = [
  { label: "首页", to: "/" },
  { label: "电影", to: "/category/movie" },
  { label: "电视剧", to: "/category/tv" },
  { label: "搜索", to: "/search" },
  { label: "关于", to: "/about" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [keyword, setKeyword] = useState("");
  const navigate = useNavigate();

  const submitSearch = (e: FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    navigate(q ? `/search?q=${encodeURIComponent(q)}` : "/search");
    setOpen(false);
  };

  return (
    <header className="sticky top-0 z-50 bg-primary-900 text-background-50 shadow-sm">
      <div className="w-full px-4 md:px-8">
        <div className="flex h-16 items-center justify-between gap-4">
          <Link
            to="/"
            className="flex items-center gap-2 shrink-0 cursor-pointer"
            onClick={() => setOpen(false)}
          >
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 text-primary-950">
              <i className="ri-movie-2-fill text-lg"></i>
            </span>
            <span className="font-heading text-lg font-black tracking-wide whitespace-nowrap">
              兔六影院
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) =>
                  `rounded-md px-4 py-2 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                    isActive
                      ? "bg-accent-500 text-primary-950"
                      : "text-background-100 hover:bg-primary-700"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <form
            onSubmit={submitSearch}
            className="hidden lg:flex items-center gap-2"
          >
            <div className="relative">
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-sm text-primary-300"></i>
              <input
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索影片、电视剧"
                className="h-9 w-52 rounded-md border border-primary-700 bg-primary-800 pl-9 pr-3 text-sm text-background-50 placeholder:text-primary-300 focus:border-accent-400 focus:outline-none"
              />
            </div>
            <button
              type="submit"
              className="h-9 rounded-md bg-accent-500 px-4 text-sm font-medium text-primary-950 hover:bg-accent-400 transition-colors cursor-pointer whitespace-nowrap"
            >
              搜索
            </button>
          </form>

          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setOpen((v) => !v)}
            className="md:hidden flex h-10 w-10 items-center justify-center rounded-md text-xl cursor-pointer"
          >
            <i className={open ? "ri-close-line" : "ri-menu-line"}></i>
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-primary-800 bg-primary-900 px-4 pb-4 pt-2">
          <form onSubmit={submitSearch} className="mb-3 flex items-center gap-2">
            <div className="relative flex-1">
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-sm text-primary-300"></i>
              <input
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索影片、电视剧"
                className="h-10 w-full rounded-md border border-primary-700 bg-primary-800 pl-9 pr-3 text-sm text-background-50 placeholder:text-primary-300 focus:border-accent-400 focus:outline-none"
              />
            </div>
            <button
              type="submit"
              className="h-10 rounded-md bg-accent-500 px-4 text-sm font-medium text-primary-950 cursor-pointer whitespace-nowrap"
            >
              搜索
            </button>
          </form>
          <nav className="flex flex-col gap-1">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `rounded-md px-4 py-3 text-sm font-medium transition-colors cursor-pointer ${
                    isActive
                      ? "bg-accent-500 text-primary-950"
                      : "text-background-100 hover:bg-primary-700"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}